var tlp;
(function (tlp) {
    document.addEventListener('ControllerReady', () => {
        const step = document.querySelector('.tlp');
        let $targets = step.querySelectorAll('.linkField');
        $targets.forEach(($target) => {
            $target.setAttribute('href', 'data:' + $target.getAttribute('href'));
            $target.setAttribute('download', 'scheda.pdf');
        });
    });
})(tlp || (tlp = {}));
